// @flow

import React from 'react'
import styled from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import LinkText from 'components/atoms/LinkText'
import UserIcon from 'components/atoms/UserIcon'
import Icon from 'components/atoms/Icon'

const SectionTitle = styled.p`
  color: ${Colors.black};
  font-size: ${fontSize.medium}px;
  ${mediaMin.phone`
    font-size: ${fontSize.medium_2}px;
  `};
`
const ReservationHostSectionWrapper = styled.div`
  text-align: center;
`
const UserIconWrapper = styled.a`
  display: inline-block;
  &:hover {
    opacity: 0.8;
  }
`
const Name = styled.p`
  margin-top: ${spacing.small_2}px;
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
`
const TopHost = styled.p`
  margin-top: ${spacing.small_3}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
`
const ContentListItem = styled.li`
  padding: ${spacing.medium_2}px 0;

  &:not(:first-of-type) {
    border-top: 1px solid ${Colors.grayE};
  }

  &:last-of-type {
    padding: ${spacing.medium_2}px 0 0;
  }
`

type PropTypes = {
  ownerPageHref: string,
  ownerImageSrc?: string,
  ownerName: string,
  topHost: boolean,
}

export default function ReservationHostSection(props: PropTypes) {
  return (
    <div>
      <SectionTitle>
        {i18n.t('page.dashboard.reservation.hostInfoDetail')}
      </SectionTitle>
      <ul>
        <ContentListItem>
          <ReservationHostSectionWrapper>
            <UserIconWrapper href={props.ownerPageHref} target="_blank">
              <UserIcon huge src={props.ownerImageSrc} />
              <Name>{props.ownerName}</Name>
            </UserIconWrapper>
            {props.topHost && (
              <TopHost>
                <Icon
                  className="icon-spm-top_host"
                  color={Colors.yellow}
                  positionType="left"
                />
                {i18n.t('page.dashboard.reservation.tophost')}
              </TopHost>
            )}
          </ReservationHostSectionWrapper>
        </ContentListItem>
      </ul>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationHostSection/index.jsx